import React, {useState, useCallback} from 'react';

import {ReactComponent as ShortcutIcon} from '../../assets/images/icons/shortcut.svg';
import {ReactComponent as AiryLogo} from '../../assets/images/logo/airy_primary_rgb.svg';
import {ListenOutsideClick} from '../general';

import styles from './index.module.scss';

const TopBar = () => {
  const [isFaqDropdownOn, setFaqDropdownOn] = useState(false);

  const faqClickHandler = useCallback(() => {
    setFaqDropdownOn(!isFaqDropdownOn);
  }, [setFaqDropdownOn, isFaqDropdownOn]);

  const hideFaqDropdown = useCallback(() => {
    setFaqDropdownOn(false);
  }, [setFaqDropdownOn]);

  return (
    <div className={styles.topBar}>
      <div className={styles.airyLogo}>
        <AiryLogo className={styles.airyLogoSvg} />
      </div>
      <div className={styles.menuArea}>
        <div className={styles.menuItem}>
          <div className={styles.help} onClick={faqClickHandler}>
            ?
          </div>

          {isFaqDropdownOn && (
            <ListenOutsideClick onOuterClick={hideFaqDropdown}>
              <div className={styles.dropdownContainer}>
                <a href="mailto:support@airy.co" className={styles.dropdownLine}>
                  <span className={styles.dropdownIcon}>
                    <ShortcutIcon />
                  </span>
                  <span>Contact us</span>
                </a>
                <a href="https://airy.co/faq" target="_blank" rel="noopener noreferrer" className={styles.dropdownLine}>
                  <span className={styles.dropdownIcon}>
                    <ShortcutIcon />
                  </span>
                  <span>FAQ</span>
                </a>
                <div className={styles.dropdownLastLine}>
                  <a className={styles.dropdownLastLink} href="https://airy.co/terms-of-service">
                    T&Cs
                  </a>
                  <a className={styles.dropdownLastLink} href="https://airy.co/privacy-policy">
                    Privacy Policy
                  </a>
                </div>
              </div>
            </ListenOutsideClick>
          )}
        </div>
      </div>
    </div>
  );
};

export default TopBar;
